import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-configure-whatsapp-business',
  templateUrl: './configure-whatsapp-business.component.html',
  styleUrls: ['./configure-whatsapp-business.component.scss']
})
export class ConfigureWhatsappBusinessComponent {
  formData = {
    phone: '',
    token: '',
    verifyToken: ''
  };

  constructor(private dialogRef: MatDialogRef<ConfigureWhatsappBusinessComponent>) {}

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    // Submit logic
    console.log(this.formData);
    this.close();
  }
}
